// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__O6wHU","LogoDiv":"Header_LogoDiv__HFbIZ","HeaderText":"Header_HeaderText__irChe"};